

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class DBDocumentLineClassification_ManagedObject

class DBDocumentLineClassification_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: autoGenerateAccount
    set autoGenerateAccount(value:boolean) {
        this.setValueForKey(value, 'autoGenerateAccount');
    }
    get autoGenerateAccount():boolean {
        return this.valueForKey('autoGenerateAccount');
    }
    set autoGenerateAccountPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'autoGenerateAccount');
    }
    get autoGenerateAccountPrimitiveValue():boolean {
        return this.primitiveValueForKey('autoGenerateAccount');
    }

    // Property: title
    set title(value:string) {
        this.setValueForKey(value, 'title');
    }
    get title():string {
        return this.valueForKey('title');
    }
    set titlePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'title');
    }
    get titlePrimitiveValue():string {
        return this.primitiveValueForKey('title');
    }
    // Relationship: ledgerAccount
    set ledgerAccount(value:LedgerAccount) {
        this.setValueForKey(value, 'ledgerAccount');
    }
    get ledgerAccount():LedgerAccount {
        return this.valueForKey('ledgerAccount') as LedgerAccount;
    }
}
